<div class="left-sign">
    <div class="inner">
        <img alt="logo" src="./../../../assets/images/logo.svg">
    <div class="text">
      <h2>Вход в систему</h2>
      <p>Укажите свои данные для авторизации. Либо пройдите регистрацию или восстановите пароль</p>
    </div>
    <app-popup-login/>
  </div>
</div>
